import React, { useEffect, useState, useCallback, useMemo, useRef } from "react"
import { AgGridReact } from "ag-grid-react"
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';

const ProgramManagerPartnerAssociationGrid = (props) => {

    const gridRef = useRef()
    const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
    const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

    const data = [{
        "Id": 1,
        "sEntryPoint": "Alok_Thakar",
        "sProgramManager": "Vaishali"
    },
    {
        "Id": 2,
        "sEntryPoint": "Agraj_Thatte",
        "sProgramManager": "Vaishali"
    },
    {
        "Id": 3,
        "sEntryPoint": "3KM",
        "sProgramManager": "Asmita"
    }
    ]

    const programManagers = ["Vaishali", "Asmita", "John", "Doe"];

    const columnDefs = [
        // {
        //     headerName: 'Id',
        //     field: 'Id',
        //     width: 100
        // },
        {
            headerName: 'Sr No.',
            valueGetter: (params) => params.node.rowIndex + 1, // Calculate row index as serial number
            width: 100,
        },
        {
            headerName: 'Partner Name',
            field: 'sEntryPoint',
            flex: 1,
            cellStyle: {
                whiteSpace: 'normal',
                wordWrap: 'break-word',
            },
            autoHeight: true,
        },
        {
            headerName: 'Program Manager Name',
            field: 'sProgramManager',
            width: 250,
            editable: true,
            cellEditorFramework: (params) => {
                const handleChange = (event) => {
                    const selectedManager = event.target.value;
                    params.node.setDataValue('sProgramManager', selectedManager);
                    params.api.stopEditing();
                    props.onEditProgramManager(selectedManager, params.data)
                };
                const defaultOption = props.programManagerList.find(
                    manager => manager.value === params.value
                );

                return (
                    <select style={{
                        width: "75%",
                        height: '50px',
                    }} // marginLeft: '42%',
                        // marginTop: "10px"
                        onChange={handleChange} defaultValue={defaultOption ? defaultOption.value : ""}>
                        <option value="" disabled>Select Program Manager</option>
                        {props.programManagerList.map((manager, index) => (
                            <option key={index} value={manager.value}>{manager.value}</option>
                        ))}
                    </select>
                );
            },
        },
    ]

    return (
        <div>
            <div style={{
                height: "75vh",
            }}>
                <div style={{ height: "100%", boxSizing: "border-box" }}>
                    <div style={gridStyle} className="ag-theme-material" >
                        <AgGridReact ref={gridRef}
                            rowData={props.tableData || []}
                            columnDefs={columnDefs}
                            pagination={true}
                            paginationPageSize={15}
                        >
                        </AgGridReact>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default ProgramManagerPartnerAssociationGrid
